import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css"
import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import "react-tabs/style/react-tabs.css";
import ReactExport from "react-export-excel";
import { Link , Redirect } from 'react-router-dom';
import matchpointlogo from '../assets/images/matchpointlogo.png';
import calender from '../assets/images/calender.png';
import logout from '../assets/images/logout.png';
import '../main.css'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import "react-table/react-table.css";
import axios from "axios";
import "antd/dist/antd.css";
import { Table, Tooltip } from "antd";

import Grid from '@material-ui/core/Grid';
import host from './ipaddress';
import Common_function from './Common_function';
import { osName,osVersion,browserName,deviceType } from 'react-device-detect';
import ApiUrlCall from './Api/apiurl';
import AuthService from '../Config/AuthService';


var gl_requestcode;
var gl_requesttype;
var gl_orderno;
var gl_list = [];
var gl_req_data = []
var timercounter = 0;

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


class Dashboardtable_demo extends Component{
  constructor(props){
    super(props);

    const token = localStorage.getItem("token")
    
    let loggedIn = true
    if(token == null){
      loggedIn = false
    }
    this.state={
      loggedIn,

      value: '',
      date: new Date(),
      host : host ,
      totalCount:'',
      startTime: "12:00 am",
      showStartTime: false,
      showEndTime: false,
      endTime: "11:59 pm",
      sendEndTime: "23:59",
      sendStartTime: "00:00",
      startDate: new Date(),
      endDate: new Date(),
      checkebox_value: [],
      user1 : localStorage.getItem("username"),
      userGroups: localStorage.getItem('user_groups'),

      lonNoList : [],
      is_checked: true,
      //radius : 0,
      options : [],
      tableData : [],
      isDisabled : false,

    }
    this.onChange = this.onChange.bind(this);
   
    this.showPassword = this.showPassword.bind(this);    
  }

componentDidMount(){
$("#loading-image").hide();
$(".loading-icon").hide();
this.sendDataToGenerateReport()
}

onRowClick = (state, rowInfo, instance) => {
  return {
    onClick: (e, handleOriginal) => {
      if (handleOriginal) {
        handleOriginal();
      }
      $(this).remove();
    }
  };
};


onChange(e) {

  if (["new_password","confirm_password"].includes(e.target.id))
  {
    if (document.getElementById('new_password').value ==
              document.getElementById('confirm_password').value) {
          document.getElementById('resetpass').disabled = false;
          document.getElementById('lbl_err').innerHTML = "Matched";
          document.getElementById('lbl_err').style.color = 'green';
        } else {          
          document.getElementById('lbl_err').innerHTML = "Not Matched"
          document.getElementById('lbl_err').style.color = 'red';
          document.getElementById('resetpass').disabled = true;
      }
  }
}




logoutHandler =(e) =>{
  var user_id = localStorage.getItem("user")
  var sha256 = require('js-sha256');
  var userid_enc = sha256(user_id);

  var active_session = {
    start_time : Common_function.ServerDateTime(localStorage.getItem("cache focus date")),
    end_time: Common_function.ServerDateTime(new Date())
  }
   console.log(active_session ,"logout time detail")
  var device_detail = [{
   event_id : 1,
  unique_id : userid_enc,
    os_version : osVersion,
    model_name: osName,
    value : active_session,user_id:user_id,
  
  }]
  
  const analytics_details = {
    data : device_detail , source : 2
  };

  
 JSON.stringify(analytics_details)

//  console.log("hello..", analytics_details)
        
  ApiUrlCall.send_analytics(analytics_details).then(response => {
     
    if (response.status === 200) {
      return

    }
  }
  )

  // Stop session services
  AuthService.stopTokenRefresh();
  AuthService.stopHeartbeat();

  // End session and logout on server
  AuthService.endSession().catch(err => console.log('End session error:', err));
  AuthService.logOut().catch(err => console.log('Logout error:', err));

  localStorage.removeItem("token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("username");
  localStorage.removeItem("mobile_number");
  localStorage.setItem('cache focus date','')


  gl_requestcode="";
  gl_requesttype="";
  gl_orderno="";
  gl_list = [];
  gl_req_data = []
  timercounter = 0;
  setTimeout(function(){
    window.location.reload()
  }, 1000);
}

showPassword = (e) => {
  var inputs = document.getElementsByClassName('mpassword');
  Array.prototype.forEach.call(inputs, function(x) {
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  })
}


onChange2 = (e) =>{
  this.setState({
    checkebox_value : e
  },() => {
    if (this.state.checkebox_value.length == 50){
      this.setState({
        isDisabled : true,
      })
      alert("You can select maximum of 50 checkbox.")
    }else{
      this.setState({
        isDisabled : false,
      })
    }
  })
} 

createServerDateTime = (date, time) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if(month <= 9){
    month = '0'+month
  }
  if(day <= 9){
    day = '0'+day
  }
  var datetime = year + "-" + month + "-" + day + " " + time + ":" + "00"
  return datetime
}

dateValidation(start, end) {
  var start = new Date(start);
  var end = new Date(end);  
  if (start > end) {
    return false
  } else {
    return true
  }
}

sendDataToGenerateReport = (e) =>{
  const {endDate,startDate,sendEndTime,sendStartTime} = this.state
  if (this.state.startDate == null){
      alert("Please select start date.")
      return
  }else{
      var start_date_time = this.createServerDateTime(startDate,sendStartTime)
    }


  this.hideAllDropDown()
  
    var data = JSON.stringify({"date" : start_date_time,})
    console.log(data ,"datt")

    $.ajax({
     
     // url: this.state.host+'/v1/mpgps/landerDashboard/tr_cars24_nrt_report/',
      
       url: this.state.host+'/v1/mpgps/landerDashboard/new_delinquent_cases/',
  
      dataType: 'json',
      type:'post',
      data:data,
      beforeSend: function(request) {
          request.setRequestHeader("authorization", localStorage.getItem("token"));
          request.setRequestHeader('api-head', JSON.stringify({"user_id":localStorage.getItem("user"),"username":localStorage.getItem("username")}));
          $("#loading-image").show();
          $(".loading-icon").show();
        },
      success: function(data) {
        $("#loading-image").hide();
        $(".loading-icon").hide();
        this.setState({
          tableData : data.data
        },() =>{
          if(this.state.tableData.length == 0){
              alert("No data found.")
          }
        })
          
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(this.props.url, status, err.toString());
        console.log('fail');
        // alert("Internal Server Error");
        $("#loading-image").hide();
        $(".loading-icon").hide();
        if(err.toString() == "Forbidden"){
         //this.logoutHandler()
        }
      }.bind(this)
    });


}

convertTime =(sec) =>{
  var hours = Math.floor(sec/3600);
  (hours >= 1) ? sec = sec - (hours*3600) : hours = '0';
  //(hours >= 10 && hours <= 1) ? sec = sec - (hours*3600) : hours = '0'+hours;
  var min = Math.floor(sec/60);
  (min >= 1) ? sec = sec - (min*60) : min = '00';
  (sec < 1) ? sec='00' : void 0;

  (min.toString().length == 1) ? min = '0'+min : void 0;    
  (sec.toString().length == 1) ? sec = '0'+sec : void 0; 

  return hours+' Hr:'+min+' Min :'+sec+" Sec";
}


////////////////////////////////////////////////////////

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
}

showStartDate = (e) => {
  $(e.currentTarget).next().slideToggle(200, "swing")
  $('#end_date_cal').slideUp()
  this.setState({
    showStartTime: false,
    showEndTime: false,
  })
}

StartdateClicked = date => {
  var isoStartDate = date
  this.setState({ startDate: isoStartDate }, () => {
    // Automatically call API when date is selected
     this.sendDataToGenerateReport()
  })
  $('#start_date_cal').slideUp(200)
}

dateFormate = (rdate) => {
  var date = new Date(rdate);
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  if (day < 10) {
    day = '0' + day;
  }
  if (month < 10) {
    month = '0' + month;
  }
  var convertDate = day + '/' + month + '/' + year
  return convertDate
}

hideAllDropDown = () => {
  $('#start_date_cal').hide()
  this.setState({
    showStartTime: false,
  })
}

/////////////////////////////////////////////////////////

render(){
  var minDate = new Date(); 
  minDate.setDate(minDate.getDate() - 90);
  if(this.state.loggedIn === false){
      return <Redirect to="/" />
    }


  const columns=[
  {
    Header: <Tooltip title="Sr No.">Sr No.</Tooltip>,
    accessor: "sr_no",
    style:{
      textAlign:"center"
    },
    Cell: (row) => { return <div>{row.index+1}</div>},
    width:100,
    minWidth:100,
    maxWidth:100
  },
  {
    Header: <Tooltip title="Los No.">Los No.</Tooltip>,
    accessor: "Los_No",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
   
   
  },
  {
    Header: <Tooltip title="Customer Name">Customer Name</Tooltip>,
    accessor: "Customer_Name",
    style:{
      textAlign:"center"
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
   
  
  
  },    
  {
    Header: <Tooltip title="Cust_Phone_No">Mobile Number</Tooltip>,
    accessor: "Cust_Phone_No",
    sortable:true,
    style:{
      textAlign:"center",
      // 'whiteSpace': 'unset'
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>},
   
  },
  
 
  {
    Header: <Tooltip title="Gps / Tracker no">Gps / Tracker no</Tooltip>,
    accessor: "Serial_number_id",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },

  {
    Header: <Tooltip title="NRT in Days">NRT in Days</Tooltip>,
    accessor: "NRT_Days",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },

  {
    Header: <Tooltip title="Last Active">Last Active</Tooltip>,
    accessor: "Last_Report_DateTime",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Battery_Disconnect_Location"> Location</Tooltip>,
    accessor: "Battery_Disconnect_Location",
    style:{
      textAlign:"center",
      float:'right',
    },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
  {
    Header: <Tooltip title="Battery_Disconnected_Time"> Disconnected Event Time</Tooltip>,
    accessor: "Battery_Disconnected_Time",
    style:{
      textAlign:"center",
        float:'right',
      },
    Cell: row =>{return <div><span title={row.value}>{row.value}</span></div>}
  },
 
  
]



  return (
    <div>
      {/*header component start*/}
      <div className="navbar navbar-default">
        <div className="container-fluid pl-0">
              <div className="navbar-header">
                <a className="header-logo">
                <Link to="/lenderdashboard"><img src={matchpointlogo} alt="matchpointlogo" width="300" className="logo"/></Link>
                </a>
              </div>
          <div className="nav navbar-nav navbar-right">
          <div className=" list-inline mb-0">
          <div id="profile_menu" className="list-inline-item fs-21 fc-red text-capitalize border-right cursor-pointer usernamemenu "
          onMouseOver={(e) => {
            //$("#profile_menu").toggle()
          }}
          onMouseLeave={(e) => {
            //$("#profile_menu").toggle()
          }}
          >
            Welcome, {this.state.user1}<span className="color-orange">
            </span>
            {/* <ul>
                <li><a href="#" data-toggle="modal" data-target="#resetPassword" >Change Password</a></li>
            </ul>  */}
             <ul>
          
          {this.state.userGroups[0] === '5' && this.state.userGroups[2] === '7' ? (
            <li>
               <Link to="/Api_integration" style={{ color: 'black', textDecoration: 'none',  }} className="custom-link" >
                 
                 <span style={{ textDecoration: 'none' }} >  Api Integration </span>

               </Link>
          </li> ) : null}
        
        </ul>

          </div>
          
          <div className="list-inline-item">
              <a onClick={e=>this.logoutHandler(e)} className="cursor-pointer">
                <img src={logout} alt="logout-logo" width="30"/>
              </a>
          </div>
          </div>
          </div>
      </div>
    </div>
    {/*header component end*/}

      {/* Range component start*/}
      <div className="container-fluid pt-35 red1">
      <Grid spacing={2} container >
          <Grid item xs>
              <p className="period-text1" >Date</p>
              <div className="gray-shadow" style = {{width : '50%'}}> 
                <div className="input_div" onClick={this.showStartDate}>
                  <input type="text" placeholder= "Date" id="start_date" disabled value={this.dateFormate(this.state.startDate)} className="journey_input"></input>
                  <img src={calender} className="calender_icon"></img>
                </div>
                <div className="calendar_parent" id="start_date_cal">
                  <Calendar
                    selectRange={false}
                    onChange={this.StartdateClicked}
                    value={this.state.startDate}
                    maxDate={this.state.date}
                    minDate={minDate}
                  />
                </div>
              </div>
              
          </Grid>

        <Grid item xs>
            <p className="period-text1"></p>
            <button type="submit" id="submit_id"   style={{ marginTop: "25px",marginLeft : "20px" }} className="btn btn-dark submit-btn" onClick={this.sendDataToGenerateReport}>Generate Report</button>
        </Grid>

        <Grid item xs>
            <p className="period-text1"></p>
            <ExcelFile element={<button className="btn btn-md btn-dark export-btn"  style={{ marginTop: "25px" }} onClick={this.ExcelFileLoader}>Export Excel Report</button>}>
                <ExcelSheet data={this.state.tableData} name="Reports">
                  <ExcelColumn label='Sr No.' value="sr_no"/>
                  <ExcelColumn label='Los_No.' value="Los_No"/>
                  <ExcelColumn label='Customer_Name' value="Customer_Name"/>
                  <ExcelColumn label='Cust_Phone_No' value="Cust_Phone_No"/>
                  <ExcelColumn label='Gps / Tracker no' value="Serial_number_id"/>
                  <ExcelColumn label='NRT in Days' value="NRT_Days"/>
                  <ExcelColumn label='Last Active' value="Last_Report_DateTime"/>
                  <ExcelColumn label='Battery_Disconnect_Location' value="Battery_Disconnect_Location"/>
                  <ExcelColumn label='Disconnected  Event Time' value="Battery_Disconnected_Time"/>
                  
                </ExcelSheet>
            </ExcelFile>
        </Grid>
      </Grid>
        <br/>
        </div>
        {/*Range component end */}

        {/* Dashboardtable component start */}
          <div className="red2">
            <div className="plr-20">
              <ReactTable columns={columns}
                  getTdProps={this.onRowClick}
                  ref={r => (this.reactTable = r)}
                  data={this.state.tableData}
                  showPagination={true}
                  pageSizeOptions = {[1000,2000]}
                  defaultPageSize={1000}
                  style={{
                    maxHeight: "630px" // This will force the table body to overflow and scroll, since there is not enough room
                  }}>
                </ReactTable>
              <div className="loading-icon" id="myDiv">
                <img id="loading-image" / >
              </div>
            </div>
          </div>
        {/* Dashboardtable component end */}

        {/* Reset Password model window start here */}
        <div class="modal fade" id="resetPassword" tabindex="-1" role="dialog" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close closebutton" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"><i class="fa fa-times"></i></span></button>
                <h4 class="modal-title">Change Your Account Password</h4>
              </div>
              <form href="" method="post" >
                <div class="modal-body">
                  <div class="form-group">
                    {/* <label for="accountEmail">Account Email</label> */}
                    <span class="help-block">Old Password.</span>
                    <input  id="old_password" type="password" onChange={this.onChange} class="form-control mpassword" required="required" name="old_password" />
                    <span  class="help-block">New Password.</span>
                    <input id="new_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="new_password" />
                    <span class="help-block ">Confirm Password.</span>
                    <input id="confirm_password" type="password" minlength="8" onChange={this.onChange} class="form-control mpassword" required="required" name="confirm_password" />
                  </div>
                  <input type="checkbox" onChange={this.showPassword} /> Show Password
                  <br/>
                  <label for="error-msg" id="lbl_err"></label>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-default btn-sm btn-icon" data-dismiss="modal">Cancel</button>
                  <button type="input" id="resetpass" onClick={this.postData} name="submit" value="resetPass" class="btn btn-success btn-sm btn-icon"> Change Password</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      {/* Reset Password model window end here */}
                          
    </div>
        )
    }
}


export default Dashboardtable_demo
